import { object } from 'yup';

import { createValidator } from '@src/validation';
import { textValidator } from '@src/validation/textValidator';

const validateSchema = object().shape({
  ctrlGroupCode: textValidator({ fieldName: 'ctrlGroupCode' }),
  ctrlGroupName: textValidator({ fieldName: 'ctrlGroupName' }),
});

export const validate = createValidator(validateSchema);
